import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { getPageLocale } from '../../../../src/web/store/modules/page';
import { getPageLocale as getPageBuilderLocale } from '../../../../src/web/store/modules/pageBuilder';
import LinkOut from '../LinkOut';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  facility: PropTypes.shape({
    linkOutUrl: PropTypes.string,
    page: PropTypes.shape({
      path: PropTypes.string,
    }),
    pagePaths: PropTypes.arrayOf(PropTypes.shape({
      locale: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })),
  }).isRequired,
  locale: PropTypes.string.isRequired,
};

const defaultProps = {
  children: undefined,
};

const FacilityLink = ({
  children,
  facility: { linkOutUrl, page, pagePaths },
  locale,
  className,
  queryString,
  ...rest
}) => {
  // if a facility has a linkOutUrl, do not find a path
  if (linkOutUrl) {
    return (
      <LinkOut href={`${linkOutUrl}${queryString || ''}`} className={className} data-testid={rest['data-testid']}>
        {children}
      </LinkOut>
    );
  }

  let path = page && page.path;

  if (!path && pagePaths) {
    const pagePath = pagePaths.find(p => p.locale === locale);
    if (pagePath && pagePath.path) {
      path = pagePath.path; // eslint-disable-line prefer-destructuring
    }
  }

  if (path) {
    return (
      <a href={`${path}${queryString || ''}`} className={className} data-testid={rest['data-testid']}>
        {children}
      </a>
    );
  }


  return (
    <span className={className} data-testid={rest['data-testid']}>
      {children}
    </span>
  );
};

FacilityLink.propTypes = propTypes;
FacilityLink.defaultProps = defaultProps;

FacilityLink.fragments = {
  facility: gql`
    fragment FacilityLinkFacility on Facility {
      id
      linkOutUrl
      applicableFeesEnabled
      address {
        state
      }
      page(locale: $locale) {
        id
        path
      }
    }
  `,
};

// the reason this component is both connected to the redux store (v1)
// and has a graphql fragment (v2) is that it is doing double duty -
// when used in the v1 flow, we use facility.pagePaths + locale from redux
// to determine the correct url for the link
// when used in the v2 flow, we use facility.page.path from the graphql fragment

export default connect(state => ({
  locale: getPageLocale(state) || getPageBuilderLocale(state),
}))(FacilityLink);
